export enum TemplateFields {
  GovernorName = 'GovernorName',
  AGName = 'AGName',
  SosName = 'SecretaryOfStateName'
}